import PhosphorIcon from '@/components/base/icon/phosphor-icon';
import { ArrowRight } from '@phosphor-icons/react';
import { clsx } from 'clsx';
import { useTranslations } from 'next-intl';
import Link from 'next/link';

interface Props {
  title?: string;
  href: string;
  entireCategory?: boolean;
  className?: string;
  textClassName?: string;
}

export const LinkItem = ({
  href,
  title,
  entireCategory,
  className,
  textClassName,
  ...rest
}: Props) => {
  const t = useTranslations('navigation.main_section');

  return (
    <li className={clsx('w-full', className)}>
      <Link
        className="!px-0 flex h-m w-full hover:underline hover:underline-offset-2 hover:outline-none"
        href={href}
        {...rest}
      >
        <div
          className={clsx(
            'flex h-full w-full items-center gap-xxs',
            entireCategory ? 'justify-start' : 'justify-between',
          )}
        >
          <span
            className={clsx(
              'whitespace-nowrap text-body text-default',
              textClassName,
            )}
          >
            {title || t('see_all')}
          </span>
          {entireCategory && (
            <PhosphorIcon
              Icon={ArrowRight}
              className={clsx('icon-s text-brand')}
            />
          )}
        </div>
      </Link>
    </li>
  );
};
